import React from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';

import { SCButton } from './styles';

Button.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
};

function Button(props) {
  return <SCButton {...props}>{props.children}</SCButton>;
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Buttons/Button.js